import './Legislation.scss';

function Mention() {
     return (
          <main className="legislation__main container--80vw">
               <section>
                    <h1>Mentions Légales</h1>
                    <article>
                         <h2>Adresse</h2>
                         <p>
                              Le site{' '}
                              <a href="https://simonlesecq.com">
                                   simonlesecq.com
                              </a>
                              , dit « le Site » est édité par :{' '}
                              <b>Lesecq Simon</b>, dit «L’éditeur», ostéopathe
                              DO {''}
                              <span className="nowrap">
                                   [SIREN : XXXXXXXXX ]
                              </span>{' '}
                              domicilié au 3 Place Clovis Tiers 59700
                              Marcq-en-Barœul{' '}
                         </p>
                         <h2>Intervenant du site</h2>
                         <p>
                              Directeur de la publication & responsable de
                              traitement: <b>Lesecq Simon</b> (
                              <a href="mailto: simon.lesecq@gmail.com">
                                   simon.lesecq@gmail.com)
                              </a>
                         </p>
                         <p>
                              Création du site web : <b>Victor Lesecq</b> (
                              <a
                                   target="blank"
                                   href="https://www.linkedin.com/in/victorlesecq/"
                              >
                                   https://www.linkedin.com/in/victorlesecq/
                              </a>
                              )
                         </p>
                         <h2>Hébergement</h2>
                         <ul>
                              <li>HOSTINGER operations,</li>
                              <li>
                                   UAB Švitrigailos str. 34, Vilnius 03230
                                   Lithuania
                              </li>
                              <li>Phone: +37064503378</li>
                              <li>Email: domains@hostinger.com</li>
                         </ul>
                         <h2>Conditions d’utilisation </h2>
                         <p>
                              Toute personne qui accède au site{' '}
                              <a href="https://simonlesecq.com">
                                   simonlesecq.com
                              </a>{' '}
                              s’engage à respecter les présentes conditions
                              générales d’utilisation, qui pourront pour
                              certains services être complétées par des
                              conditions particulières.{' '}
                         </p>
                         <p>
                              L’éditeur se réserve le droit de modifier et de
                              mettre à jour à tout moment l’accès au Site ainsi
                              que les Conditions Générales. Ces modifications et
                              mises à jour s’imposent à l’utilisateur qui doit
                              en conséquence se référer régulièrement à cette
                              rubrique pour vérifier les Conditions Générales en
                              vigueur.
                         </p>
                         <h2>Responsabilité</h2>
                         <p>
                              L’ensemble des informations accessibles via ce
                              site sont fournies en l’état. <b>Lesecq Simon</b>{' '}
                              ne donne aucune garantie, explicite ou implicite,
                              et n’assume aucune responsabilité relative à
                              l’utilisation de ces informations.{' '}
                              <b>Lesecq Simon</b> n’est pas responsable ni de
                              l’exactitude, ni des erreurs, ni des omissions
                              contenues sur ce site. L’utilisateur est seul
                              responsable de l’utilisation de telles
                              informations. <b>Lesecq Simon</b> se réserve le
                              droit de modifier à tout moment les présentes
                              notamment en actualisant ce site.{' '}
                              <b>Lesecq Simon</b> ne pourra être responsable
                              pour quel que dommage que ce soit tant direct
                              qu’indirect, résultant d’une information contenue
                              sur ce site.{' '}
                         </p>
                         <p>
                              L’utilisateur s’engage à ne transmettre sur ce
                              site aucune information pouvant entraîner une
                              responsabilité civile ou pénale et s’engage à ce
                              titre à ne pas divulguer via ce site des
                              informations illégales, contraires à l’ordre
                              public ou diffamatoires.
                         </p>
                         <h2>Cookies </h2>
                         <p>
                              Les « cookies » sont des fichiers texte de petite
                              taille que l’administrateur d’un serveur installe
                              sur votre ordinateur et qui permettent de
                              mémoriser des données relatives à l’internaute
                              lorsque celui-ci se connecte au site. Il ne s’agit
                              en aucun cas de mémoriser des données personnelles
                              vous concernant. Ce sont donc des outils destinés
                              à faciliter la consultation du site. Les cookies
                              utilisés à ce jour (02/02/2024) sont liés à
                              l'utilisation des services suivants :
                         </p>
                         <ul>
                              <li>
                                   <b>Google Fonts :</b> Utilisation : Nous
                                   utilisons Google Fonts pour l’affichage des
                                   polices web. Pour plus d’informations,
                                   veuillez lire la{' '}
                                   <a href="https://policies.google.com/privacy">
                                        déclaration de confidentialité Google
                                        Fonts
                                   </a>
                              </li>
                              <li>
                                   <b>Google Maps :</b> Utilisation : Nous
                                   utilisons Google Maps pour l’affichage des
                                   cartes. Pour plus d’informations, veuillez
                                   lire la{' '}
                                   <a href="https://policies.google.com/privacy">
                                        déclaration de confidentialité Google
                                        Maps
                                   </a>
                              </li>
                              <li>
                                   <b>Fontawesome :</b> Utilisation : Nous
                                   utilisons Fontawesome pour l’affichage des
                                   pictogrammes. Pour plus d’informations,
                                   veuillez lire la{' '}
                                   <a href="https://fontawesome.com/privacy">
                                        déclaration de confidentialité
                                        Fontawesome
                                   </a>
                              </li>
                         </ul>
                         <p>
                              <b>Lesecq Simon</b> peut être amené à installer
                              d’autres cookies de ce type.
                         </p>
                         <h2>Données personnelles et autres données</h2>
                         <p>
                              Le site est exempté de déclaration à la Commission
                              Nationale Informatique et Libertés (CNIL) dans la
                              mesure où il ne collecte aucune donnée concernant
                              les utilisateurs.
                         </p>
                         <h2>Liens hypertextes </h2>
                         <p>
                              Le Site peut contenir des liens hypertexte donnant
                              accès à d’autres sites web édités et gérés par des
                              tiers et non par l’Editeur. L’Editeur ne pourra
                              être tenu responsable directement ou indirectement
                              dans le cas où lesdits sites tiers ne
                              respecteraient pas les dispositions légales.
                         </p>
                         <h2>Coordonnées</h2>
                         <div className="contact">
                              <p>Simon Lesecq</p>
                              <p>3 Place Clovis Tiers </p>
                              <p>59700 Marcq-en-Barœul</p>
                              <p>France</p>
                              <p>
                                   Site web :{' '}
                                   <a href="https://simonlesecq.com">
                                        https://simonlesecq.com
                                   </a>
                              </p>
                              <p>
                                   E-mail :{' '}
                                   <a href="mailto: simon.lesecq@gmail.com">
                                        simon.lesecq@gmail.com
                                   </a>
                              </p>
                              <p>Numéro de téléphone: 06. 85. 47. 92. 37.</p>
                         </div>
                    </article>
               </section>
          </main>
     );
}

export default Mention;
